import {
    Create,
    Datagrid,
    List,
    Edit,
    Show,
    SimpleShowLayout,
    TextField,
    Pagination,
    SelectField,
    ReferenceField,
    ReferenceArrayField,
    ReferenceArrayInput,
} from "react-admin";
import { SimpleForm, TextInput } from "react-admin";
import { LongDateField, ShortDateField } from "./customFields";
import { BulkActionButtons } from "./common";
import { ArtistReferenceInput } from "./artists";

const ddexArtistMappingFilters = [
    <TextInput source="q" label="Search" alwaysOn />,
    <ArtistReferenceInput source="artist_id" label="Artist" />,
    <TextInput source="from_party_id" label="Party id" />,
];

export const DDEXArtistMappingList = () => (
    <List
        filters={ddexArtistMappingFilters}
        perPage={50}
        pagination={<Pagination rowsPerPageOptions={[25, 50, 100, 200]} />}
        sort={{ field: "created_at", order: "DESC" }}
    >
        <Datagrid rowClick="show" bulkActionButtons={<BulkActionButtons />}>
            <TextField source="name" />
            <TextField source="from_party_id" />
            <ReferenceField label="Artist" reference="artists" source="artist_id" sortable={false} />
            <ShortDateField source="created_at" label="Added on" />
        </Datagrid>
    </List>
);

export const DDEXArtistMappingShow = () => (
    <Show>
        <SimpleShowLayout>
            <h2>DDEXArtistMapping</h2>

            <TextField source="id" />
            <TextField source="name" />
            <TextField source="from_party_id" />
            <ReferenceField label="Artist" reference="artists" source="artist_id" />
            <ShortDateField source="created_at" label="Added on" />
        </SimpleShowLayout>
    </Show>
);

export const DDEXArtistMappingCreate = () => (
    <Create>
        <SimpleForm>
            <h2>Add DDEXArtistMapping</h2>

            <TextInput source="from_party_id" fullWidth label="Party id" />
            <TextInput source="name" fullWidth />
            <div style={{ width: "400px" }}>
                <ArtistReferenceInput source="artist_id" />
            </div>
        </SimpleForm>
    </Create>
);

export const DDEXArtistMappingEdit = () => (
    <Edit mutationMode="pessimistic">
        <SimpleForm>
            <h2>Edit DDEXArtistMapping</h2>

            <TextInput source="from_party_id" fullWidth label="Party id" />
            <TextInput source="name" fullWidth />
            <div style={{ width: "400px" }}>
                <ArtistReferenceInput source="artist_id" />
            </div>
        </SimpleForm>
    </Edit>
);
